module.exports = __webpack_public_path__ + "static/media/lige.569dd2ca.png";